import React from 'react';
import { getMetaDescription } from '@/utils/getMetaDescription';
import { checkForWrongDomain } from '@/utils/checkForWrongDomain';
import Layout from '@/components/Layout';
import Shop from '../../containers/Shop';
import { getSSRStoreData } from '../../utils/ssrPageData';
import { useSetSSRStore, useSSRSelector } from '../../redux';
import { getRequiredCtxProps } from 'src/utils/getRequiredCtxProps';

const ShopPage = (props) => {
  useSetSSRStore(props.ssrStore);
  const storeInfo = useSSRSelector((state) => state.storeReducer.store);
  return (
    <Layout
      store={storeInfo}
      title={`${storeInfo?.store_info?.name}${
        storeInfo?.address?.city
          ? Boolean(storeInfo?.address?.visibility === 1)
            ? `, ${storeInfo?.address?.city}`
            : ''
          : ''
      } - Order Online`}
      Icon={storeInfo?.store_info?.logo_image}
      metaDescription={storeInfo && getMetaDescription(storeInfo)}
      OGImage={storeInfo?.store_info?.logo_image}
      isCustomDomain={props.isCustomDomain}
      {...props}
    >
      <section>
        <Shop {...props} />
      </section>
    </Layout>
  );
};

export async function getServerSideProps(ctx) {
  if (checkForWrongDomain(ctx)) return {};
  let propData = {
    catalogCategories: [],
    catalogTags: [],
    collections: [],
  };

  const propType = await getSSRStoreData(ctx, {
    checkForCustomThemeShopUrl: true,
    additionalDataToFetch: ['collections', 'categories'],
  });

  const extraProps = getRequiredCtxProps(ctx, propType);

  propData = { ...propData, ...propType };

  return { props: { ...propData, ...extraProps } };
}

export default ShopPage;
